import type OwaViewStateConfiguration from '../contract/OwaViewStateConfiguration';
import type UserOptionsType from '../contract/UserOptionsType';
import type RecursiveReadOnly from '../RecursiveReadOnly';

// To move an UserOptionsType or OwaViewStateConfiguration property from OwaUserConfiguration to
// AccountScopeUserSettings, add it to one of these arrays.
export const accountScopeUserOptionsProperties = [] as const;
export const accountScopeViewStateConfigurationProperties = [] as const;

export type AccountScopeUserOptionsKeys = typeof accountScopeUserOptionsProperties[number];
export type AccountScopeViewStateConfigurationKeys = typeof accountScopeViewStateConfigurationProperties[number];

export type AccountScopeUserSettings = {
    UserOptions: Pick<UserOptionsType, AccountScopeUserOptionsKeys>;
    ViewStateConfiguration: Pick<OwaViewStateConfiguration, AccountScopeViewStateConfigurationKeys>;

    // Task 132129: Folder Maps in session store should be per account
    // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/132129
    // Placeholder for now, but expecting these will move in here before the account scope work is complete.
    // defaultFolderIdToNameMap: ReadonlyMap<string, string>;
    // defaultFolderNameToIdMap: ReadonlyMap<string, string>;
};
export type ReadOnlyAccountScopeUserSettings = RecursiveReadOnly<AccountScopeUserSettings>;
